import { useState, useEffect } from 'react'
import { getSearchCompletions } from 'services/searchCompletions'

const useSearchCompletions = (searchTerm: string, shouldAutocomplete: boolean) => {
    const [searchCompletions, setSearchCompletions] = useState([] as string[])
    const [error, setError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        const fetchData = async () => {
            if (!searchTerm) {
                return
            }
            try {
                const response = await getSearchCompletions(searchTerm)
                const {
                    searchBox: { universal = [] },
                } = response.data
                // Results could be either completion, category or product.
                const completions = universal.reduce((acc, current) => {
                    // Only supporting text completions for now
                    if ('completion' in current) {
                        acc.push(current.completion.text)
                    }
                    return acc
                }, [] as string[])

                setSearchCompletions(completions)
                setError(false)

                setIsLoading(false)
            } catch (err) {
                setError(true)
            }
        }
        setIsLoading(false)
        if (searchTerm && shouldAutocomplete) {
            fetchData()
        }
    }, [searchTerm, shouldAutocomplete])

    const clearSearchResults = () => setSearchCompletions([])

    return { isLoading, error, searchCompletions, clearSearchResults }
}

export default useSearchCompletions
